// Add your custom JS here.
import Shuffle from 'shufflejs';
// import * as bootstrap from 'bootstrap';
// https://github.com/understrap/understrap/issues/1583
import Modal from 'bootstrap/js/dist/modal'


const prodGrids= document.querySelectorAll('.siit-prodGrid');
if ( prodGrids !== null ){

    prodGrids.forEach( (grid) => {

        var myShuffle = new Shuffle(grid, {
            itemSelector: '.siit-prod',
            sizer: '.my-sizer-element',
            buffer: 1,
            useTransforms: true,
            delimiter: ','
        });

        var parentModal = grid.closest('.modal');
        parentModal.addEventListener('shown.bs.modal', event => {
            myShuffle.filter('all');
            //window.location.hash = parentModal.id;
        });
        console.log(parentModal)
               
    
        var radios = parentModal.querySelectorAll('.siit-filter');
        radios.forEach(radio => {
            radio.addEventListener('click', function (el) {
                myShuffle.filter(el.target.value);
                radios.forEach(btn => btn.classList.remove('active'));
                el.target.classList.add('active');
            }, false);
        });

    });
    
}

// PAGINA PRODOTTI
// SCROLLA ALL'AREA TERAPEUTICA
if (document.body.classList.contains('page-template-page-products')) {


    // scrollTo
    const scrollToAreaLinks = document.querySelectorAll('#scrollToArea li a');
    scrollToAreaLinks.forEach( (el)=> {
        el.addEventListener('click', (e) => {
            let targetArea = e.target.getAttribute("href").substring(1);
            console.log('targetArea');
            e.preventDefault();
            window.scroll({ top: document.getElementById(targetArea).offsetTop - 195, left: 0, behavior: 'smooth' });
        });
    })
    

    // filtro 2
    // source https://codepen.io/srga/pen/aboByyN
    'use strict';
    // var Shuffle = window.Shuffle;

    var Demo = function (element) {
        this.technologies = Array.from(document.querySelectorAll('input.filterTechnology'));
        this.tipologie = Array.from(document.querySelectorAll('input.filterType'));

        this.shuffle = new Shuffle(element, {
            easing: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)', // easeOutQuart
            sizer: '.my-sizer-element',
        });

        this.filters = {
            technologies: [],
            tipologie: [],
        };

        this._bindEventListeners();
    };

    /**
     * Bind event listeners for when the filters change.
     */
    Demo.prototype._bindEventListeners = function () {
        this._onTechnologyChange = this._handleTechnologyChange.bind(this);
        this._onTipologiaChange = this._handleTipologiaChange.bind(this);

        this.technologies.forEach(function (input) {
            input.addEventListener('change', this._onTechnologyChange);
        }, this);

        this.tipologie.forEach(function (input) {
            input.addEventListener('change', this._onTipologiaChange);
        }, this);
    };

    /**
     * Get the values of each checked input.
     * @return {Array.<string>}
     */
    Demo.prototype._getCurrentTechnologyFilters = function () {
        return this.technologies.filter(function (input) {
            return input.checked;
        }).map(function (input) {
            return input.value;
        });
    };

    /**
     * Get the values of each `active` button.
     * @return {Array.<string>}
     */
    Demo.prototype._getCurrentTipologiaFilters = function () {
        return this.tipologie.filter(function (input) {
            return input.checked;
        }).map(function (input) {
            return input.value;
        });
    };


    /**
     * A technology input check state changed, update the current filters and filte.r
     */
    Demo.prototype._handleTechnologyChange = function () {
        this.filters.technologies = this._getCurrentTechnologyFilters();
        this.filter();
    };

    /**
     * A tipologia button was clicked. Update filters and display.
     * @param {Event} evt Click event object.
     */
    Demo.prototype._handleTipologiaChange = function () {
        this.filters.tipologie = this._getCurrentTipologiaFilters();
        this.filter();
    };

    /**
     * Filter shuffle based on the current state of filters.
     */
    Demo.prototype.filter = function () {
        if (this.hasActiveFilters()) {
            this.shuffle.filter(this.itemPassesFilters.bind(this));
        } else {
            this.shuffle.filter(Shuffle.ALL_ITEMS);
        }
    };

    /**
     * If any of the arrays in the `filters` property have a length of more than zero,
     * that means there is an active filter.
     * @return {boolean}
     */
    Demo.prototype.hasActiveFilters = function () {
        return Object.keys(this.filters).some(function (key) {
            return this.filters[key].length > 0;
        }, this);
    };

    /**
     * Determine whether an element passes the current filters.
     * @param {Element} element Element to test.
     * @return {boolean} Whether it satisfies all current filters.
     */
    Demo.prototype.itemPassesFilters = function (element) {
        var technologies = this.filters.technologies;
        var tipologie = this.filters.tipologie;
        var technology = element.getAttribute('data-groups');
        var tipologia = element.getAttribute('data-types');

        // If there are active technology filters and this technology is not in that array.
        if (technologies.length > 0){
            var technologyArr = ( technology )? technology.split(',') : [];

            if ( technologies.filter(item => technologyArr.includes(item)).length  == 0 ){
                return false;
            }
            
            // if( !technologies.includes(technology)) {
            //     return false;
            // }
        }

        // If there are active tipologia filters and this tipologia is not in that array.
        if (tipologie.length > 0 && !tipologie.includes(tipologia)) {
            return false;
        }

        return true;
    };

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.siit-filterable').forEach( (prodArea)=>{
            window.demo = new Demo( prodArea );
        });

        if ( window.location.hash && document.querySelector( window.location.hash ) ) {
            document.querySelector( window.location.hash ).click();
        }

       // window.demo = new Demo(document.querySelector('.siit-filterable'));
    });


    // // filtro
    // document.querySelectorAll('.siit-filterable').forEach( (prodArea)=>{

    //     let myShuffle = new Shuffle(prodArea, {
    //         itemSelector: '.siit-prod',
    //         sizer: '.my-sizer-element',
    //         buffer: 1,
    //         useTransforms: true,
    //         delimiter: ',',
    //         filterMode:  'all',
    //     });

    //     // select filter
    //     // https://codepen.io/Vestride/details/qBVRKvx
    //     let filterTechnologies = '';
    //     const filterTechnology = document.querySelectorAll('input[name="filterTechnology"]');
    //     // ogni volta che clicco, raccolgo quelli selezionati e filtro.



    //     // let filterTechnology = document.getElementById('filterTechnology');
    //     // filterTechnology.addEventListener('change', (e) => {
    //     //     let targetTech = filterTechnology.value;
    //     //     e.preventDefault();
    //     //     myShuffle.filter(targetTech);
    //     // });
        
    //     // document.querySelectorAll('input[name="filterType"]').forEach(check => {
    //     //     check.addEventListener('click', function (el) {
    //     //         let checkedChecks = document.querySelectorAll('input[name="filterType"]:checked').length;
    //     //         let targetTech = filterTechnology.value;
    //     //         console.log(checkedChecks);
    //     //         console.log(targetTech);
    //     //         if ( checkedChecks == 2){
    //     //             if (targetTech !== ''){
    //     //                 myShuffle.filter(targetTech);
    //     //             } else {
    //     //                 myShuffle.filter();
    //     //             }
    //     //         } else if (checkedChecks == 1){
    //     //             myShuffle.filter( document.querySelectorAll('input[name="filterType"]:checked').value, targetTech);
    //     //         } else {
    //     //             // checkka l'altro
    //     //         }

                
    //     //     }, false);
    //     // });

    // });

}


// caroselli semplici in singleProduct e taxonomyTechnology
import Splide from '@splidejs/splide';
const splides = document.getElementsByClassName( 'splide--siit' );

if (splides.length >= 1){

    const elms = document.getElementsByClassName( 'splide--siit' );
    
    for ( var i = 0; i < elms.length; i++ ) {
        new Splide( elms[ i ] ).mount();
    }

    if ( document.getElementById('img-carousel') ){
        document.addEventListener( 'DOMContentLoaded', function () {
            var imgCarousel = new Splide( '#img-carousel', {
            rewind    : true,
            pagination: false,
            arrows    : true,
            } );
        
            var thumbCarousel = new Splide( '#thumbnail-carousel', {
            fixedWidth  : 90,
            fixedHeight : 90,
            gap         : 16,
            rewind      : true,
            pagination  : false,
            isNavigation: true,
            arrows    : false,
            } );
        
            imgCarousel.sync( thumbCarousel );
            imgCarousel.mount();
            thumbCarousel.mount();
        });
    }
}


// TRIG MODALI PER URL   
if ( document.body.classList.contains('page-template-page-areas') && window.location.hash && document.querySelector( window.location.hash ) ) {
    new Modal( document.querySelector( window.location.hash ) ).show();
}

// TRIG MODALI PER URL  in pagina prodotto 
if ( document.body.classList.contains('single-product') && window.location.hash && window.location.hash == '#loginOk' ) {
    new Modal( document.getElementById( 'loginModalOk' ) ).show();
}
